export const STOCKEXCHANGEINTIMATIONS ='STOCKEXCHANGEINTIMATIONS';